import { Component, Input, OnInit } from '@angular/core';
import { APIService } from '../../api.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { EnterExpenseComponent } from '../enter-expense/enter-expense.component';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-production-output',
  templateUrl: './production-output.component.html',
  styleUrls: ['./production-output.component.scss']

})
export class ProductionOutputComponent implements OnInit {
  @Input() mdlRef: any;
  @Input() jobDetails : any;
  @Input() productItems : any;
  @Input() prTypeID: number = 1;
  // @Input() costSum: number = 0

  productItemsTarget : any = [];
  productionOutData: any = [];
  items: any = [];
  jarvisData: any = [];
  mTable: any = [];
  isWeb: boolean = true;
  editIndex: number = -1;
  changeQty: number = 0;
  modalReference: any;
  costSum: number = 0;
  rights = {
    materialIssue: true,
    storeSelect: true,
    prdCfg : false,
    allPrd : false
  };
  userData: any = []
  constructor(private apiService: APIService, private modalService: NgbModal, private dataSer : DataService) { }

  ngOnInit(): void {
    
  //Get Data For Items Details.
    this.productionOutData = this.jobDetails;
  //Get  Data For Products Items.
    this.productItemsTarget = this.productItems;
    console.log("productItemsTarget", this.productItemsTarget)


    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    var tableM = this.apiService.getCookie('M');
    if (tableM) {
      this.mTable = JSON.parse(tableM);
    }
    var user = this.apiService.getCookie("J");
    if (user) {
      this.userData = JSON.parse(user);
    }
    
    this.isWeb = this.apiService.apiCheckWeb();
    debugger

    if(this.prTypeID == 2){
      this.dataSer.projectData.subscribe((value : any) => {
        debugger
        if(value.jobID && value.jobID == this.productionOutData[0].JobID){
          if(value.costSum && value.costSum != undefined && value.costSum != ''){
            this.costSum = value.costSum;
          }
        }
        else
        {
          this.costSum = 0;
        }
       
      });
  
    }

    this.getRigths();
  }

  getRigths(){
    for(let i = 0; i < this.userData.length; i++){
      if(this.jarvisData[0].UserID == this.userData[i].UserID){     
        this.rights.prdCfg = this.userData[i].PrdCfg;
        this.rights.allPrd = this.userData[i].Prd;
      }
    }
  }
  costTypeListMdl(content: any, id: number) {
    this.modalReference = this.modalService.open(EnterExpenseComponent, { windowClass: 'costTypeMdl', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.isFromCostTypeList = true;
    this.modalReference.componentInstance.jobDetails = this.jobDetails;

  }
   // openBatchMdl() - Open Batch entry modal 	
   costTypeEntryMDl(content: any, id: number) {
    this.modalReference = this.modalService.open(EnterExpenseComponent, { windowClass: 'costTypeEntryMdl', backdrop: 'static', keyboard: false });
    this.modalReference.componentInstance.mdlRef = this.modalReference;
    this.modalReference.componentInstance.isFromCostTypeEntry = true;
    this.modalReference.componentInstance.jobDetails = this.jobDetails;
  }
  openTransaction(obj: any) {
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    window.open(
      'transactionJobs;id=' + obj + ';jobID=' + this.productionOutData[0].JobID,
      target
    );
  }

  editQty(obj: any, i:number) {
    obj.IsSelect = true;
    obj.tmpQty = obj.PlanQty;

    this.editIndex  = i;
  }

  cancel(obj: any) {
    obj.IsSelect = false;
    obj.PlanQty = obj.tmpQty;
  }

  saveItem() {

    let generationList: any = [];
    for (let i = 0; i < this.productItemsTarget.length; i++) {
      if (this.productItemsTarget[i].PlanQty < this.productItemsTarget[i].GenQty) {
        alert('please enter valid qty');
        return;
      }

      if(this.editIndex == i){
        this.changeQty = this.productItemsTarget[i].PlanQty;
      }
      
      let obj = {
        ItemID: this.productItemsTarget[i].PID,
        PlanQty: this.productItemsTarget[i].PlanQty + '',
        DoneQty: this.productItemsTarget[i].GenQty + '',
        XnIDs: '',
        Description: this.productItemsTarget[i].D ? this.productItemsTarget[i].D : '',
      };
      generationList.push(obj);
    }

    let ConsumptionList: any = [];
    for (let i = 0; i < this.items.length; i++) {
      let obj = {
        ItemID: this.items[i].MID,
        PlanQty: this.items[i].PlanQty + '',
        DoneQty: this.items[i].UsedQty + '',
        XnIDs: '',
        Description: this.items[i].D ? this.items[i].D : '',
      };
      ConsumptionList.push(obj);
    }

    let MyLastSyncDT = localStorage.getItem('MyLastSyncDT');

    var tempData = [
      {
        JobID: this.productionOutData[0].JobID,
        TargetDT: new Date(),
        Stages: this.productionOutData[0].Stages,
        Generation: JSON.stringify(generationList),
        Consumption: JSON.stringify(ConsumptionList),
      },
    ];

    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: MyLastSyncDT,
        isWeb: true,
        ForERPAgencyID: this.mTable[0].ERPAgencyID,
        actionType: 'setDetail',
        moduleID: 7,
        data: JSON.stringify(tempData),
      },
    ];

    this.apiService.sendChange(
      myParams,
      this.successRespSaveItems.bind(this),
      this.failureRespSaveItems.bind(this)
    );
  }

  successRespSaveItems(res: any,i:number){
    if (res.error) {
      console.log(res.message);
    } else {
        if(this.editIndex > -1){
          this.cancel(this.productItemsTarget[this.editIndex]);
          this.productItemsTarget[this.editIndex].PlanQty = this.changeQty;
          this.editIndex = -1;
          this.changeQty = 0;
        }
    }
  }

  failureRespSaveItems(res: any){
    if (res.error) {
      console.log(res.message);
    } else {
      alert(res.message);
    }
  }  

//Delete Items
deleteItems(ind: number) {
            console.log(ind);
            if(confirm("Are you sure delete this item?")) {
              this.productItemsTarget.splice(ind, 1);
              this.saveItem();
            }
        }
  goBack(){
    this.mdlRef.close('Close');
  }

  viewFile() {
    if (this.productionOutData[0].Attachment && this.productionOutData[0].Attachment != '') {
      const strAgn = this.mTable[0].ERPAgencyID.toString().padStart(10, '0');
      const biziFilesURL = this.apiService.getBiziFilesURL();
      
      let fileURL = `${biziFilesURL}Files/${strAgn}/Jobs/${this.productionOutData[0].Attachment}`;

      if (this.isWeb) {
        // Open in popup window
        const windowFeatures = 'width=1000,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,status=no';
        window.open(fileURL, 'DescriptorFile', windowFeatures);
      } else {
        // Open in same window for mobile app
        window.location.href = fileURL;
      }
    }
  }
}
